import { useDocumentTitle as useTitle } from '@mantine/hooks';

import { useStore } from '../store';

export function useDocumentTitle(title?: string) {
  const tenantName = useStore((state) => state.tenantName);

  const breadCrumbs = title ? title.replace(/-/g, ' ').split('/') : [];

  if (tenantName) {
    breadCrumbs.unshift(tenantName);
  }

  useTitle(breadCrumbs.join(' | '));
}
